/*
 * @Editor: chenqy
 * @Description: 
 * @Date: 2023-11-10 16:40:12
 * @LastEditors: Chenqy
 * @LastEditTime: 2023-11-10 16:44:05
 */
let loading = false;

export default {
  loadEcharts(tag) {
    return new Promise((resolve, reject) => {
      if (!window.echarts && !window.$echarts) {
        let fn = () => {
          window.$echarts = window.echarts;
          //加载完成
          resolve();
        }
        /****观察者模式动态加载echarts script 标签，防止多次加载script   start******************/
        dsf.emit.$on("loadCharts", fn, tag);
        if (!loading) {
          loading = true;
          dsf.http
            .importFiles([dsf.url.getWebPath('$/js/libs/echarts/echarts.min.js')])
            .then(() => {
              dsf.emit.$emit('loadCharts');
            })
            .catch((err) => {
              dsf.layer.message('加载echarts文件报错', false)
              reject(err);
            }).finally(() => {
              dsf.emit.$remove("loadCharts", fn, tag);
            })
        }
        return;
      }
      //加载完成
      resolve();
    })
  }
}